import React, { useState } from 'react';
import { Menu, Code, MapPin } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { cppTranslations } from '../../translations/cpp-translations';
import LanguageToggle from '../LanguageToggle';

const CppHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language } = useLanguage();
  const t = cppTranslations[language];

  return (
    <header className="cpp-header">
      <div className="cpp-container">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <Code className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="cpp-heading-3 text-white mb-0">Qubit Center</div>
              <div className="flex items-center gap-1 text-sm text-blue-400">
                <MapPin className="w-3 h-3" />
                <span>Amman</span>
              </div>
            </div>
          </div>
          
          <nav className="hidden md:flex items-center gap-8">
            <a href="#curriculum" className="text-gray-300 hover:text-blue-400 transition-colors">
              {t.curriculum}
            </a>
            <a href="#features" className="text-gray-300 hover:text-blue-400 transition-colors">
              {t.features}
            </a>
            <a href="#schedule" className="text-gray-300 hover:text-blue-400 transition-colors">
              {t.schedule}
            </a>
            <a href="#contact" className="text-gray-300 hover:text-blue-400 transition-colors">
              {t.contact}
            </a>
          </nav>
          
          <div className="flex items-center gap-4">
            <LanguageToggle />
            <button 
              onClick={() => {
                const contactSection = document.getElementById('contact');
                contactSection?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="cpp-btn-secondary text-sm px-4 py-2"
            >
              {language === 'ar' ? 'سجل الآن' : 'Enroll Now'}
            </button>
            <button 
              className="md:hidden p-2 text-gray-300 hover:text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <Menu className="w-5 h-5" />
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-700">
            <nav className="flex flex-col gap-4 mt-4">
              <a href="#curriculum" className="text-gray-300 hover:text-blue-400 transition-colors">
                {t.curriculum}
              </a>
              <a href="#features" className="text-gray-300 hover:text-blue-400 transition-colors">
                {t.features}
              </a>
              <a href="#schedule" className="text-gray-300 hover:text-blue-400 transition-colors">
                {t.schedule}
              </a>
              <a href="#contact" className="text-gray-300 hover:text-blue-400 transition-colors">
                {t.contact}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default CppHeader;